import { render, staticRenderFns } from "./MatrizRiesgos.vue?vue&type=template&id=e78662c2&"
import script from "./MatrizRiesgos.vue?vue&type=script&lang=js&"
export * from "./MatrizRiesgos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports